module.exports = {
    api_config : {
        api_endpoint : "https://rgcdtp-kdstudy-api.rugcc.org/api/v1",
        current_environment : "kdstudy"
    }
};